/* global postscribe */
/* global adScriptUrl */

require("./impression-tracker");

(function($, postscribe, kruxSasHelper, scriptUrl, global) {
    $(function() {
        $("div[data-ad-tile]").each(function() {
            var elm = $(this);
            var sasTags = "", gaTags = "";
            var url = scriptUrl;

            if (kruxSasHelper) {
                const sasTagsValue = kruxSasHelper().getSasTags();
                sasTags = `/${sasTagsValue}`;
                gaTags = kruxSasHelper().getGaTags();
            } else {
                console.warn("KruxSasHelper not loaded");
            }

            if (elm.data("adKruxRequired") == "true") {
                url += sasTags;
            }

            url += `/size=${elm.data("adSizes")}/tile=${elm.data("adTile")}`;
            url += gaTags;

            elm.data("src-url", url);

            postscribe(elm,
                `<script src='${url}'></script>`,
                {
                    done: function() {
                        elm.css("background", "none");
                    }
                });

            if (elm.data("reload-on")) {
                $(global).on(elm.data("reload-on"),
                    function() {
                        reloadAd(elm);
                    });
            }
        });

        function reloadAd(elm) {
            if (!global.adReloadingForTile || !global.adReloadingForTile[elm.data("ad-tile")]) {
                global.adReloadingForTile = global.adReloadingForTile || [];
                global.adReloadingForTile[elm.data("ad-tile")] = true;

                const min = 1000000000;
                const max = 9999999999;
                const random = Math.floor(Math.random() * (max - min + 1) + min);
                const viewid = Math.floor(Math.random() * (max - min + 1) + min);
                const newUrl = elm.data("src-url")
                    .replace(/(viewid=).*?(\/|$)/, `$1${viewid}$2`)
                    .replace(/(random=).*?(\/|$)/, `$1${random}$2`);

                elm.empty();
                elm.data("src-url", newUrl);

                postscribe(elm,
                    `<script src='${newUrl}'></script>`,
                    {
                        done: function() {
                            global.adReloadingForTile[elm.data("ad-tile")] = false;
                        },
                        error: function(err) {
                            elm.empty();
                        }
                    });

            }
        }
    });
})(jQuery, postscribe, window.KruxSasHelper, adScriptUrl, window);